import ImageUploader from "../../components/ImageUploader";

const CURRENCIES = [
  { symbol: "₹", label: "₹  Indian Rupee (INR)" },
  { symbol: "$", label: "$  US Dollar (USD)" },
  { symbol: "€", label: "€  Euro (EUR)" },
  { symbol: "£", label: "£  British Pound (GBP)" },
  { symbol: "AED ", label: "AED  UAE Dirham" },
  { symbol: "₦", label: "₦  Nigerian Naira (NGN)" },
];

const inputCls =
  "w-full mt-1 bg-white border border-[#E8E4D9] rounded-lg px-4 py-3 focus:outline-none focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary)]";

export default function AdminStoreInfo({ settings, setField, onSave, saving }) {
  return (
    <form onSubmit={onSave} className="mt-6 max-w-2xl bg-white border border-[#E8E4D9] rounded-xl p-6 space-y-5">
      <ImageUploader
        label="Store Logo"
        testid="logo"
        aspect="aspect-video"
        value={settings.logo_url}
        onChange={(v) => setField("logo_url", v)}
      />

      <div>
        <label className="text-sm font-medium text-[#1A231C]">Store Name</label>
        <input data-testid="settings-store-name" value={settings.store_name || ""} onChange={(e) => setField("store_name", e.target.value)} className={inputCls} />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-[#1A231C]">Currency</label>
          <select data-testid="settings-currency" value={settings.currency_symbol || "₹"} onChange={(e) => setField("currency_symbol", e.target.value)} className={inputCls}>
            {CURRENCIES.map((c) => (
              <option key={c.symbol} value={c.symbol}>{c.label}</option>
            ))}
          </select>
        </div>
        <div>
          <label className="text-sm font-medium text-[#1A231C]">WhatsApp Number</label>
          <input data-testid="settings-whatsapp" value={settings.whatsapp_number || ""} onChange={(e) => setField("whatsapp_number", e.target.value)} placeholder="e.g. 919876543210" className={inputCls} />
          <p className="text-xs text-[#5C665D] mt-1">Country code + number, digits only. Orders are sent here.</p>
        </div>
      </div>

      <div>
        <label className="text-sm font-medium text-[#1A231C]">Contact Address</label>
        <input data-testid="settings-address" value={settings.contact_address || ""} onChange={(e) => setField("contact_address", e.target.value)} className={inputCls} />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="text-sm font-medium text-[#1A231C]">Contact Phone</label>
          <input data-testid="settings-phone" value={settings.contact_phone || ""} onChange={(e) => setField("contact_phone", e.target.value)} className={inputCls} />
        </div>
        <div>
          <label className="text-sm font-medium text-[#1A231C]">Contact Email</label>
          <input data-testid="settings-email" value={settings.contact_email || ""} onChange={(e) => setField("contact_email", e.target.value)} className={inputCls} />
        </div>
      </div>

      <div>
        <label className="text-sm font-medium text-[#1A231C]">Footer Text</label>
        <textarea data-testid="settings-footer-text" value={settings.footer_text || ""} onChange={(e) => setField("footer_text", e.target.value)} rows={2} className={inputCls} />
      </div>

      <button data-testid="settings-save" type="submit" disabled={saving} className="bg-[var(--brand-primary)] text-white px-6 py-3 rounded-lg font-medium hover:bg-[var(--brand-primary-hover)] transition-colors disabled:opacity-60">
        {saving ? "Saving..." : "Save Store Info"}
      </button>
    </form>
  );
}
